export default __webpack_public_path__ + "static/media/KIO-logo.618d094c.png";